import React, {createContext, useState} from 'react'
import axios from 'axios';

const Context = createContext()

let userislogin = false


if(localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-token`) !== null){
    userislogin = true
}else{
    userislogin = false
}

//const _URL_REST = globals.get('_URL_REST');
const Provider = ({children}) => {
    
    const [isAuth, setIsAuth] = useState(userislogin)
    
    const [modaIsOpen, setModaIsOpen] = useState(false);
    const [showRecovery, setShowRecovery] = useState(false);
    const [showRegistro, setshowRegistro] = useState(false);
    const value = {
        isAuth,
        modaIsOpen,
        showRecovery,
        showRegistro,
        activateAuth: () =>{
            console.log('USER LOGIN OK')
            setIsAuth(true)
            
        },
        removeAuth: () =>{
            localStorage.clear()
            setIsAuth(false)
            
        },
        modaToggle: (val) => {
            window.scrollTo(0, 0)
            setshowRegistro(false)
            setShowRecovery(false)
            setModaIsOpen(val)
            
        },
        showRecoveryToggle: (val) => {
            window.scrollTo(0, 0)
            setshowRegistro(false)
            setShowRecovery(val)
            
        },
        showRegistroToggle: (val) => {
            window.scrollTo(0, 0)
            setShowRecovery(false)
            setshowRegistro(val)
        },
        logEvento:  (idEvento,esBajoDemanda, accion=null,  valorAccion=null) => {
            /*console.log('##### grabar log::')
            console.log('log usuario:: ',localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-idu`))
            console.log('log idevento:: ',idEvento)
            console.log('log esbajodemanda:: ',esBajoDemanda)
            console.log('log accion:: ',accion)
            console.log('log AccionValor:: ',valorAccion)
            console.log('##### end grabar log:: ')*/
            //console.log('grabar log http://api.ipify.org/?format=json')
            
           axios.get(`https://webinars.spinmedia.es/ip.php`)
            .then((dataip) => {
                
                
                let dataFormlog = {  
                    "idUsuario": localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-idu`),
                    "idEvento": idEvento,
                    "ip": dataip.data.ip,
                    "BajoDemanda": esBajoDemanda,
                    "Navegador": `${window.navigator.userAgent}`,
                    "accion":accion,
                    "accionValor":valorAccion
                }
                let axiosConfig = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization':`Bearer ${localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-token`)}`
                    },  
                };
               //console.log('LOG::',dataFormlog)
               axios.post(`${process.env.REACT_APP_URL_API}eventos/GrabarEventoLogs`, dataFormlog, axiosConfig)
               .then((res) => {
                  
                   console.log('Log::',res.data)
                   
                   
               })
               .catch((err) => {
                 console.log('Log ERROR::',err)
               }) 
                
                
            })
            .catch((err) => {
                console.log('Log ERROR IP::',err)
              })
              
            
            
           
        }
  
    }


    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    )
}



export default{
    Provider,
    Consumer: Context.Consumer
}